'use client';

import { Container, Image, Section } from '@bytel/trilogy-react';

import type { HomeBannerData } from '@helpers/home-banner';

interface HomeBannerProps {
    banner: HomeBannerData;
}

export function HomeBanner({
    banner: { logo, logoAlt, bannerUrlDesktop, bannerUrlMobile },
}: Readonly<HomeBannerProps>) {
    return (
        <Section className='is-paddingless'>
            <div className='homeBanner is-hidden-mobile' style={{ backgroundImage: `url(${bannerUrlDesktop})` }}>
                <Image src={logo} alt={logoAlt} />
            </div>
            <Container className='is-hidden-desktop is-hidden-tablet'>
                <div className='homeBanner' style={{ backgroundImage: `url(${bannerUrlMobile})` }}>
                    <Image className='ml-1' src={logo} alt={logoAlt} />
                </div>
            </Container>
        </Section>
    );
}
